import { render, staticRenderFns } from "./AccountSelection.vue?vue&type=template&id=27ffd45b&scoped=true&"
import script from "./AccountSelection.vue?vue&type=script&lang=js&"
export * from "./AccountSelection.vue?vue&type=script&lang=js&"
import style0 from "./AccountSelection.vue?vue&type=style&index=0&id=27ffd45b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ffd45b",
  null
  
)

export default component.exports